<template>
  <div class="container">
    <div class="text-block">
      <div class="text-block--inner">
        <h4 class="text-block--text">
          <slot />
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.text-block {
  width: 980px;
  margin: 0 auto;
}
.text-block--inner {
  padding-top: 180px;
  padding-bottom: 100px;
}
.text-block--inner h4 {
  font-size: 2.3125rem;
  line-height: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  transform: translateY(20%);
  opacity: 0;
}
@media screen and (min-width: 900px) and (max-width: 1279px) {
  .text-block {
    width: 680px;
  }
}
@media screen and (min-width: 730px) and (max-width: 899px) {
  .text-block {
    width: 540px;
  }
  .text-block--inner h4 {
    font-size: 1.875rem;
    line-height: 2.125rem;
  }
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  .intro-wrap {
    flex-flow: column;
  }
}
@media screen and (max-width: 729px) {
  .text-block {
    width: calc(100% - 48px);
  }
  .text-block--inner {
    padding-top: 140px;
    padding-bottom: 80px;
  }
  .text-block--inner h4 {
    font-size: 1.875rem;
    line-height: 2.125rem;
  }
  .intro-wrap {
    flex-flow: column;
  }
  .--left {
    width: 100%;
    padding-right: 0;
  }
}
@media screen and (max-width: 429px) {
  .text-block {
    width: 100%;
  }
  .text-block--inner h4 {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
  .text-block--inner {
    padding-top: 100px;
    padding-bottom: 60px;
  }
}
</style>
